import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import { ProductCard, ProductCardSkeleton } from "../components/Card";
import { ProductModal } from "../components/Modal";
import { ProductApi } from "../app/api/product.api";
import productData from "../app/data/productData";


export function Product() 
{
   
  const [showDetail, setShowDetail] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [name, setName] = useState("");

  const product = ProductApi(); 
  const [filteredData, setFilteredData] = useState([]);
  const [listSubcategories, setlistSubcategories] = useState([]);
  
  const fetchData = async () => { 
    const {data} = await product.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["products"], queryFn: fetchData });
  
  
  const handleInputs = (event) => {
    const { name, value } = event.target;
    if( name === 'category' ) {
        const selectedCategory = productData.subcategories.find(item => item.category === value);
        setlistSubcategories(selectedCategory ? selectedCategory.listItems : []);
        setCategory(value);
    }
    if( name === 'subcategory' ) {
        setSubcategory(value);
    }
    if( name === 'name' ) {
        setName(value);
    }
  }

  useEffect(() => {
  
      if (!Array.isArray(data)) return;
      let filtered = data;
  
      if (category) filtered = filtered.filter(item => item.category?.toLowerCase() === category.toLowerCase() );
      if (subcategory) filtered = filtered.filter(item => item.subcategory?.toLowerCase() === subcategory.toLowerCase() );
      if (name) filtered = filtered.filter(item => item.name?.toLowerCase().startsWith(name.toLowerCase()) );
     
      setFilteredData(filtered);
  
  }, [data, category, subcategory, name]);  


  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  };


  return(

    <div className='container-fluid' >

      {/* _____________________SECTION HEADER EQUIPMENT ___________________ */} 

      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={2} /> </div>
            
      {/* _____________________SECTION 1 EQUIPMENT ___________________ */} 

      <section className='row'>
        <div className='col-12'>
           <div className="shop-header-section">
              {/* Fil d'Ariane / Titre */}
              <div className="row bg-light-gray py-5 text-center">
                <h1 className="fw-bold display-5"> Collection Ortega </h1>
                <nav className="breadcrumb-nav">
                  <a href="/"><i className="bi bi-grid me-1"></i> Produits </a>
                  <span> / </span>
                  <span className="text-muted"> Tous </span>
                </nav>
              </div>

              {/* Barre de Filtres et Contrôles */}
              <div className="row justify-content-center">
              <div className="col-lg-11 mt-5">
                <div className="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-4">
                  {/* Vue Grille/Liste */}
                  <div className="d-flex align-items-center gap-3 display-controls">
                    <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                    <span className="text-muted lead"> Liste de nos produits </span>
                  </div>
                  {/* Infos et Tris */}
                  <div className="d-flex align-items-center gap-3 filter-controls">
                    <span className="text-muted small border px-3 py-1"> { filteredData.length } produit(s)</span>
                  </div>
                </div>

                {/* Boutons de Filtres Catégories */}
                <div className="d-flex gap-2 flex-wrap mb-5">
                  <div className="d-flex gap-2 align-items-center">
                    <select className="border w-100 p-2 text-secondary" value={category} name="category" onChange={ handleInputs } required >
                      <option value="">Choisir une catégorie </option>
                      {
                        productData.categories.map((item, index)=> ( 
                          <option value={item.name} key={index}> {item.content} </option> 
                        ))
                      }
                    </select>
                    <select className="border w-100 p-2 text-secondary" name="subcategory" onChange={ handleInputs } required >
                      <option value="">Choisir une sous-catégorie </option>
                      {
                        listSubcategories.map((item, index)=> ( 
                          <option value={item.name} key={index}> {item.content} </option> 
                        ))
                      }
                    </select>
                  </div>
                  {/* SEARCH BAR */}
                  <div className="d-flex align-items-center">
                    <input type="search" className="w-100 px-3 py-2 border text-secondary" placeholder="Rechercher un produit..." value={name} name="name" onChange={ handleInputs } required />
                    <span className="border py-2 px-2"> <i className="bi bi-search text-muted"></i> </span>                 
                  </div>
                </div>

              </div>
              </div>
            </div>
         </div>
      </section>

      {/* _____________________SECTION 2 EQUIPMENT ___________________ */} 

      <section className='row justify-content-center mb-5 pb-5'>
        <div className='col-lg-11'>
          <div className="row">          
              
              {/* Loading */}
              {isLoading && (
                [...Array(4)].map((_, index) => (
                  <ProductCardSkeleton key={index} />
                ))
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                filteredData.map((product, index) => (
                  <ProductCard
                    key={index}
                    product={product}
                    detail={() => handleEdit(product)}
                  />
                ))
              )}
              
              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}
                          
           </div>      
        </div>
      </section>

      {/* _____________________SECTION FOOTER EQUIPMENT ___________________ */} 
    
      <div className='row'>
        <Footer />
      </div>

      {/* Modal de previsualisation */}
      {
        selectedProduct && ( <ProductModal show={showDetail} product={selectedProduct} onHide={() => setShowDetail(false)} /> )
      }
      

    </div>

  )
}

